const langtrans={
      lxhhxh:["旅行地图、风险预警","travel map、risk warning"],
      myccxh:["每一次出行，都让人安心！","You do not have to feel worried about any travel!"],
      ddjxww:["大救星为旅行社提供便捷、高效的全球救援，并为旅行团队量身设计整体解决方案。领队可在大救星APP上创建出行群组、绑定保险，并在任何紧急时刻使用一键救命，同时在地图、定位、预警、呼叫等工具的辅助下，为团队成员提供令人安心的出行安全服务。","The Great Suvior will offer the travel agency a kind of convenient and efficient global Assistance, moreover, it can design the general solution plan for a travel team. The tour leader can set a travelling group, bound the group member to the insurance, and also can press the 'HELP' button at any emergency. Simultaneously, with the assistance of different tools like map, location,early-warming and calling, this app can secure the safty of those team members"],
      cxhhxh:["出行经验、自救指南","travel experience、self-help guide"],
      dddjss:["定点集散、呼叫团员","Fixed point distributiing team member calling"],
      ssdwxx:["实时定位、消息共享","Real time locating、Message Sharing"],
      yjjm:["一键救命","'HELP' button"],
      xsxyy:["小时响应","h"],
      qqyyqb:["全球有求必救","all-weather available global-reaction"],
      aqgj:["安全工具","safty tool"],
      jlhgzz:["建立合作","To establish cooperation"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/TravelAgency.vue.trans.js